import { ActivatedRoute } from '@angular/router';
import { Injectable, Optional } from '@angular/core';
import { EVENTS } from '../constants';
import { User } from '../models';
import { EnvironmentConfig } from './config';

declare const gtag: any;
declare const mixpanel: any;
declare const analytics: any;
declare const EF: any;
declare const fbq: any;
declare const _hsq: any;
declare const hj: any;

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  constructor(private route: ActivatedRoute, @Optional() private config: EnvironmentConfig) { }

  track(event: string, data: any) {
    if (this.config.production === true) {
      switch (event) {
        case EVENTS.PAGEVIEW:
          this.track_pageview(data);
          break;
        case EVENTS.SESSION_START:
          this.track_login(data);
          break;
        case EVENTS.USER_CREATED:
          this.track_signup(data);
          break;
        case EVENTS.PROPERTY_LISTING:
          this.track_listing(data);
          break;
        case EVENTS.CHECKOUT:
          this.track_checkout();
          break;
        case EVENTS.PURCHASE:
          this.track_purchase(data);
          break;
        case EVENTS.FAILED_PURCHASE:
          this.track_bookingNotSuccessful(data);
          break;
        case EVENTS.ADD_CARD_PAYMENT:
          this.track_add_card_payment();
          break;
        case EVENTS.CONTACT:
          this.track_contact();
          break;
        case EVENTS.SEARCH_PROPERTY:
          this.track_property_search(data)
          break;
        case EVENTS.DELETE_PROPERTY:
          this.track_delete_my_property(data)
          break;
        case EVENTS.CREATE_PROPERTY:
          this.track_create_listing(data)
          break;
        case EVENTS.PUBLISH_PROPERTY:
          this.track_publish_property(data)
          break;
        case EVENTS.UNPUBLISH_PROPERTY:
          this.track_unpublish_property(data)
          break;
        case EVENTS.SEND_MESSAGE:
          this.track_send_message()
          break;
        case EVENTS.INITIATE_REQUEST_BOOKING:
          this.track_initiate_request_booking(data)
          break;
        case EVENTS.REQUEST_BOOKING:
          this.track_request_booking(data)
          break;
        case EVENTS.VIEW_PROPERTY:
          this.track_single_property(data)
          break;
        case EVENTS.VIEW_PAYMENTS:
          this.track_payment(data)
          this.track_payment_page()
          break;
        case EVENTS.UPDATE_USER:
          this.track_edit_profile(data)
          break;
        case EVENTS.EDIT_USER_PASSWORD:
          this.track_change_password(data)
          break;
        case EVENTS.SOCIAL_SHARE:
          this.track_social_share(data)
          break;
        case EVENTS.CTA_CLICKS:
          this.track_cta_click(data)
          break;
        case EVENTS.CLICK_BLOG_POST:
          this.track_view_blog_post(data)
          break;
        case EVENTS.CLICK_LOCATIONS:
          this.track_location_clicks(data)
          break;
        case EVENTS.CLICK_FOOTER_LINKS:
          this.track_footer_link_clicks(data)
          break;
        case EVENTS.CLICK_LISTING_CAROUSELS:
          this.track_listing_carousel_clicks(data)
          break;
        case EVENTS.NO_PROPERTY_FOUND:
          this.track_no_property_form(data)
          break;
        case EVENTS.INSTALL_PWA:
          this.track_new_pwa_installation()
          break;
        case EVENTS.LAUNCH_PWA:
          this.track_launcing_pwa()
          break;
        case EVENTS.ASSISTED_BOOKINGS:
          this.track_assisted_booking(data)
          break;
        case EVENTS.EXPENSE_UPLOAD:
          this.track_expense_upload(data)
          break;

      }
    }
  }

  private track_login(user: User) {
    this.track_user(user);
    // Set the user ID using signed-in user_id
    if (typeof gtag !== 'undefined') {
      // gtag('set', { user_id: user.id });
    }
    if (typeof mixpanel !== 'undefined') {
      mixpanel.people.set({
        $last_login: new Date()
      })
      mixpanel.track('Login')
    }
    if (typeof analytics !== 'undefined') {
      analytics.track('Login')
    }
  }

  private track_signup(user: User) {
    this.track_user(user);
    // Set the user ID using signed-in user_id
    if (typeof gtag !== 'undefined') {
      // gtag('set', { user_id: user.id })
      gtag('event', 'conversion', { send_to: 'AW-401067724/pG5uCKKUnf8BEMydn78B' })
    }
    if (typeof gtag !== 'undefined') {
      // gtag('set', { user_id: user.id })
      gtag('event', 'sign_up', { send_to: 'AW-401067724/pG5uCKKUnf8BEMydn78B' })
    }

    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Sign up')
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Sign Up');
    }
    if (typeof fbq !== 'undefined') {
      fbq('track', 'CompleteRegistration');
    }
    if (typeof gtag !== 'undefined') {
      gtag('event', 'NEW_USER_SIGN_UP', {
        'event_category': 'NEW_USER_SIGN_UP_CATEGORY',
        'event_label': 'NEW_USER_SIGN_UP_CATEGORY',
      })
    }
    const _hsq = (window as any)._hsp = (window as any)._hsq || [];

    if (typeof _hsq !== 'undefined') {
      _hsq.push(['identify', {
        name: `${user.first_name}${user.last_name}`,
        firstname: user.first_name,
        lastname: user.last_name,
        email: user.email,
        email_verified: user.email_verified || false,
        phone: user.phone,
        phone_verified: user.phone_verified || false
      }]);
    }

    // const _hsq = (window as any)._hsp = (window as any)._hsq || [];
    if (typeof EF !== 'undefined') {
      EF.conversion({ aid: 45 })
    }

  }

  private track_listing(property: any) {
    if (typeof EF !== 'undefined') {
      EF.conversion({
        aid: 45,
        event_id: 215,
      })
    }
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Get Property Listings', { 'path': property })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Get Property Listings');
    }

  }


  private track_payment(payment: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('View My Payment History', { 'path': payment.route })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'View My Payment History');
    }
  }

  private track_user(user: User) {
    if (typeof gtag !== 'undefined') {
      gtag('set', { user_id: user.id });
    }
    // const _hsq = (window as any)._hsp = (window as any)._hsq || [];

    if (typeof _hsq !== 'undefined') {
      _hsq.push(['identify', {
        name: `${user.first_name}${user.last_name}`,
        firstname: user.first_name,
        lastname: user.last_name,
        email: user.email,
        email_verified: user.email_verified || false,
        phone: user.phone,
        phone_verified: user.phone_verified || false
      }]);
    }
    if (typeof analytics !== 'undefined') {
      const { email, first_name, last_name, id, createdAt } = user
      analytics.identify(id, {
        name: `${first_name} ${last_name}`,
        email
      })
      analytics.setAnonymousId(id)
      // analytics.track('Login')
    }
    if (typeof mixpanel !== 'undefined') {
      const { email, first_name, last_name, id, createdAt } = user;
      mixpanel.identify(id)
      mixpanel.people.set_once({
        $email: email, $name: `${first_name} ${last_name}`, $created: createdAt, $last_login: new Date()
      })
      // mixpanel.track('Sign up')
    }
  }

  private track_pageview(user: User) {
    // Set the user ID using signed-in user_id
    if (typeof fbq !== 'undefined') {
      fbq('track', 'PageView');
    }
    if (typeof _hsq !== 'undefined') {
      _hsq.push(['setPath', this.route.snapshot.url]);
      _hsq.push(['trackPageView']);
    }
  }

  private track_purchase(amount: number) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Purchase', { value: amount, currency: 'GBP' });
    }
    if (typeof gtag !== 'undefined') {
      gtag('event', 'BOOKING_PAYMENT_COMPLETED', {
        'event_category': 'BOOKING_PAYMENT_COMPLETED_CATEGORY',
        'event_label': 'BOOKING_PAYMENT_COMPLETED_LABEL',
      })
    }
  }
  private track_bookingNotSuccessful(amount: number) {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Purchase Not successful', { value: amount, currency: 'GBP' });
    }
    if (typeof gtag !== 'undefined') {
      gtag('event', 'BOOKING_PAYMENT_NOT_COMPLETED', {
        'event_category': 'BOOKING_PAYMENT_NOT_COMPLETED_CATEGORY',
        'event_label': 'BOOKING_PAYMENT_NOT_COMPLETED_LABEL',
      })
    }
  }

  private track_checkout() {
    // Set the user ID using signed-in user_id
    if (typeof fbq !== 'undefined') {
      fbq('track', 'InitiateCheckout');
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Initiate Checkout');
    }
  }

  private track_add_card_payment() {
    // Set the user ID using signed-in user_id
    if (typeof fbq !== 'undefined') {
      fbq('track', 'AddPaymentInfo');
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Add payment Info');
    }
  }

  private track_contact() {
    // Set the user ID using signed-in user_id
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Contact');
    }

    if (typeof mixpanel !== 'undefined') {
      mixpanel.track_forms('Submit Form')
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Submit Form');
    }
  }

  private track_property_search(data: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Search Location', { 'path': data })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Search Location');
    }
  }

  private track_delete_my_property(data: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Delete My Property', { 'path': data.route, 'Property': data.id })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Delete My Property');
    }
  }

  private track_create_listing(data: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Create New Property', { 'path': data })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Create New Property');
    }
  }

  private track_publish_property(property: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Publish My Property', { 'path': property.route, 'Property': property.id })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Publish My Property');
    }
  }
  private track_unpublish_property(property: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Unpublish My Property', { 'path': property.route, 'Property': property.id })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Unpublish My Property');
    }
  }

  private track_send_message() {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Send Message to Owner')
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Send Message to Owner');
    }
  }
  private track_initiate_request_booking(property: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Initate Booking Request', { 'path': property.route })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Intiate Booking Request');
    }
  }
  private track_request_booking(property: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Complete Booking Request ', { 'path': property.route })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Complete Booking Request');
    }
  }
  private track_single_property(property: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('View Single Property', { 'path': property.route, 'Property': property.id, 'App': property.app })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'View Single Property');
    }
  }
  private track_edit_property(property: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Edit My Property', { 'path': property.route, 'Property': property.id })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Edit My Property');
    }
  }
  private track_payment_page() {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('View Payment History')
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'View Payment History');
    }
  }
  private track_edit_profile(data: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Edit My Profile')
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Edit My Profile');
    }
  }
  private track_change_password(data: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Change My Password')
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Change My Password');
    }
  }
  private track_social_share(data: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Share and Earn', { 'path': data.route, 'Medium': data.platform })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Share and Earn');
    }
  }

  private track_cta_click(data: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Click CTA on Website', { 'path': data.route, 'section': data.section, 'page': data.page })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Click CTA on Website');
    }
  }

  private track_view_blog_post(blog: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('View Single Blog Post', { 'path': blog.route, 'post': blog.post })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'View Blog Post');
    }
  }
  private track_location_clicks(location: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('View Locations', { 'path': location.route, 'location': location.name })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'View Location');
    }
  }
  private track_footer_link_clicks(footer: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Footer Links', { 'page': footer.route, 'link': footer.link })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Footer Links');
    }

  }
  private track_listing_carousel_clicks(property: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Listing Carousel Click', { 'page': property.route, 'Platform': property.platform, 'property-name': property.name })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Listing Carousel Click');
    }
  }
  private track_no_property_form(location: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Submit No Property Form', { 'page': location.route, 'params': location.params })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Submit No Property Form');
    }
  }
  private track_new_pwa_installation() {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('NEW PWA INSTALLATION')
    }

  }

  private track_launcing_pwa() {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('RE-LAUNCH PWA')
    }

  }

  private track_assisted_booking(data: { route: string }) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Submit Assisted Bookings Form', { 'page': data.route })
    }

    if (typeof hj !== 'undefined') {
      hj('event', 'Submit Assisted Bookings Form');
    }

  }

  private track_expense_upload(data: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.track('Expense Upload', { 'path': data.route })
    }
    if (typeof hj !== 'undefined') {
      hj('event', 'Expense Upload');
    }
  }






}
